import {get, post, postJson} from './axios'

// 系统批次短信效果分析

const RESOURCE_BASE_PATH = '/memberLabel'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/memberLabel'
// const RESOURCE_BASE_PATH = 'http://192.168.1.235:8000/jd-yusms/memberLabel'

// 人群交并差计算（用于精准营销中的计算人群）
export const caculateMember = p => postJson(`${RESOURCE_BASE_PATH}/caculate`, p);

// 获取地区信息
export const getArea = p => get(`${RESOURCE_BASE_PATH}/area`);